import React from 'react';

const UserGroupManagement = () => {
    return (
        <div>
            
        </div>
    );
};

export default UserGroupManagement;